// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1XSVL","loaderOuter":"PageOverlayLoader_loaderOuter__Mjm1J"};